import { type ComponentProps, memo } from "react"

import ReactMarkdown from "react-markdown"

type MarkdownConfig = Omit<ComponentProps<typeof ReactMarkdown>, "children">

type StableBlockProps = {
  html: string
  config: MarkdownConfig
}

/**
 * A memoized markdown block that renders once and never re-renders.
 * Used for frozen (completed) content segments during streaming.
 */
export const StableBlock = memo(
  function StableBlock({ html, config }: StableBlockProps) {
    return <ReactMarkdown {...config}>{html}</ReactMarkdown>
  },
  (prev, next) => prev.html === next.html && prev.config === next.config
)
